(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let lastWidth = window.innerWidth;

    const updateLockedHeroHeights = (force = false) => {
      const currentWidth = window.innerWidth;

      if (!force && Math.abs(currentWidth - lastWidth) < 40) return;

      lastWidth = currentWidth;

      document.querySelectorAll('[data-lock-mobile-viewport="true"]').forEach((hero) => {
        if (mobileQuery.matches) {
          hero.style.setProperty('--hero-locked-mobile-height', `${window.innerHeight}px`);
        } else {
          hero.style.removeProperty('--hero-locked-mobile-height');
        }
      });
    };

    const initializeLockedHeroHeights = () => {
      lastWidth = window.innerWidth;
      updateLockedHeroHeights(true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeLockedHeroHeights, { once: true });
    } else {
      initializeLockedHeroHeights();
    }

    window.addEventListener('resize', () => updateLockedHeroHeights(false), { passive: true });
    window.addEventListener('orientationchange', () => {
      requestAnimationFrame(() => updateLockedHeroHeights(true));
    });
    document.addEventListener('shopify:section:load', () => updateLockedHeroHeights(true));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
